import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './CompanyLogos.css'
// import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
// import ReactTooltip from 'react-tooltip'
// import moment from 'moment'

@CSSModules(Styles)
export default class CompanyLogos extends Component {
  static propTypes = {
    holdings: PropTypes.array,
    fHoldingsMap: PropTypes.object
  }
  constructor(props){
    super(props)
  }

  render() {
    // "investments in top fossil fuel companies"
    // go through holdings
    // see if they match against list of top 100
    // display logo if so
    // alt text: holding data
    // sort: holding assets desc
    // display 10 max

    // error check?
    if (
      !this.props.holdings ||
      this.props.holdings.length === 0 ||
      !this.props.fHoldingsMap ||
      this.props.fHoldingsMap.length === 0
    ) {
      return null
    }

    const MAX_MATCHES = 6
    let matchCount = 0
    // const matches = []
    const topMatches = this.props.holdings.filter((x)=>{
      const isMatch = x.is_c2 === true || x.is_f15 === true
      if (isMatch && matchCount < MAX_MATCHES) {
        matchCount += 1
        return true
      } else {
        return false
      }
    })
    // console.log(topMatches)

    if (!topMatches || topMatches.length === 0) {
      return null
    }

    // icon images
    const iconC2 = require( '../../../static/images/icn-c2-active.svg' )
    const iconF5 = require( '../../../static/images/icn-f5-active.svg' )

    const iconConfigs = [
      ['is_c2', iconC2, 'Carbon Underground 200', 'Top 200 carbon reserves'],
      ['is_f15', iconF5, 'Macroclimate 50', 'Top 50 coal-fired power'],
    ]

    //
    return (
      <div styleName='wrapper'>
        <div styleName='company-logo-wrap'>
          {
            topMatches.map((el, idx) => {
              let hasLogo = false
              let companyLogo = null
              try {
                companyLogo = require('../../../static/images/cos/'+el.company_id+'.png')
                hasLogo = true
              }
              catch (e) {
                // console.log('')
              }

              const fMoney = format.money(
                this.props.fHoldingsMap[el.id].market_value,
                true,
                'USD', // shareClass.currency,
                false
              )

              return (
                <div
                  key={'top-match-'+idx}
                  styleName='item-wrap'
                >
                  <div
                    styleName='company-logo-img-wrap'
                    title={el.security_name}
                  >
                    {
                      hasLogo ?
                      (
                        <img
                          styleName='company-logo-img'
                          src={companyLogo}
                          alt={el.security_name}
                        />
                      ):
                      (
                        <span>
                          {el.security_name}
                        </span>
                      )
                    }
                  </div>
                  <div styleName='company-logo-details'>
                    <div styleName='company-logo-icons'>
                      { /* mini-sector icons */
                        iconConfigs.map((sector, i)=>{
                          return el[sector[0]] ?
                            (
                              <span
                                styleName='detail-icon-holding-wrp'
                                key={sector[0]+'_'+i}
                              >
                                <img
                                  styleName='detail-icon-holding'
                                  src={sector[1]}
                                  alt={sector[2]}
                                  title={sector[2]}
                                />
                                {sector[3]}
                              </span>
                            ) :
                            null
                        })
                      }
                    </div>
                    <div styleName='company-logo-assets'>
                      {fMoney}
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

